export default {
  oneMonth: {
    is: '1 mánuður',
    en: '1 month',
  },
  threeMonths: {
    is: '3 mánuðir',
    en: '3 months',
  },
  sixMonths: {
    is: '6 mánuðir',
    en: '6 months',
  },
  yearToDate: {
    is: 'Á árinu',
    en: 'Year to date',
  },
  oneYear: {
    is: '1 ár',
    en: '1 year',
  },
  twoYears: {
    is: '2 ár',
    en: '2 years',
  },
  threeYears: {
    is: '3 ár',
    en: '3 years',
  },
  fourYears: {
    is: '4 ár',
    en: '4 years',
  },
  fiveYears: {
    is: '5 ár',
    en: '5 years',
  },
};
